<template>
  <!--  预算编制-->
  <div style="width:100%">

    <van-collapse v-model="activeNames">
      <van-collapse-item title="基本信息" name="1">
        <van-field v-model="inputForm.code" label="单据编号" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.name" label="单据名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.paymentCompanyName" label="付款公司" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorDeptName" label="申请部门" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.requestUserName" label="报销人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.requestAmount" label="报销总额（元）" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorCompanyName" label="申请公司" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.businessTime" label="申请日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.personYearAmount" label="报销人本年累计（元）" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.payeeName" label="受款人名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="padding-left: 16px;" v-show="inputForm.attachList&&inputForm.attachList.length > 0">
          <p>相关附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <van-field v-model="inputForm.createByName" label="制单人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.remarks" label="报销事由" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="padding-left: 16px;" v-show="inputForm.attachList2&&inputForm.attachList2.length > 0">
          <p>事前相关流程</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList2" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <van-field label="详细信息" label-width="100px" readonly>
          <template #button>
            <van-button plain type="default" @click="viewClaim">查看明细</van-button>
          </template>
        </van-field>
        <van-field label="预算信息" label-width="100px" readonly v-if="inputForm.costBudgetDTOList&&inputForm.costBudgetDTOList.length>0">
          <template #button>
            <van-button plain type="default" @click="viewBudget">查看明细</van-button>
          </template>
        </van-field>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import QueryInfoService from '@/api/system/queryInfoService'

export default {
  name: "socialWeal",
  data(){
    return {
      activeNames: ['1'],
      inputForm:{
        id:'',
        code:'',
        operatorCompanyName:'',
        operatorDeptName:'',
        businessTime:'',
        requestUserName:'',
        projectName:'',
        mainstayType:'',
        mainstayObj:'',
        mainstayCompanyId:'',
        paymentCompanyId:'',
        operatorName:'',
        createDate:'',
        attachList2:[],
        type:'',
        name:'',
        contractName:'',
        totalMaterialAmount:'',
        contractAmount:'',
        totalRequestAmount:'',
        payeeType:'',
        payeeName:'',
        payeeBank:'',
        payeeBankAccount:'',
        payeePerson:'',
        requestAmount:'',
        requestBigAmount:'',
        requestRateAmount:'',
        paymentAmount:'',
        attachList3:[],
        invoiceAmount:'',
        invoiceBigAmount:'',
        invoiceRateAmount:'',
        countersignCode:'',
        countersignDate:'',
        countersignContent:'',
        remarks:'',
        attachList:[],
        workloadEstimateDetailList:[],
        budgetControl:'',
        budgetAnnualId:'',
        specialProjectName:'',
        costBudgetDTOList:[],
        costRequestChargeDetailDTOList:[],
        costInvoiceDTOList:[],
      }
    }
  },
  created() {
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    init(data) {
      this.$nextTick(()=>{
        this.inputForm = data
        this.updateDictNames(this.inputForm.costEventClaimDetailDTOList,{cost_business_type:'businessType',cost_contract_budget_control:'budgetControl'})
        // this.updateDictNames(this.inputForm.costEventClaimDetailDTOList,{cost_contract_budget_control:'budgetControl'})
        this.inputForm.costEventClaimDetailDTOList.forEach((i)=>{
          if(i.mainstayType=='1'){
            i.mainstay=i.mainstayCompanyName+'-'+i.mainstayDeptName
          }else {
            i.mainstay=i.mainstayCompanyName
          }
        })
        this.inputForm.createByName=data.createBy.name
        const amounts = [
          [this.inputForm.personYearAmount, 'personYearAmount'],
          [this.inputForm.requestAmount, 'requestAmount'],
        ].map(([value, formField]) => {
          this.$set(this.inputForm, `${formField}`, Number(value).toFixed(2));
        });
        this.updateDictNames(this.inputForm.costBudgetDTOList,{cost_contract_budget_control:'budgetControl'})
        this.inputForm.createDate =  this.inputForm.createDate.slice(0,10)
      })
    },

    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Name`, dictItem.label);
            }
          }
        }
      });
    },
    viewClaim() {
      const fieldsList=[
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'mainstay',  label: '费用承担对象'},
        {key: 'budgetProjectName',  label: '所属项目'},
        {key: 'pensionAmount',  label: '养老保险（元）'},
        {key: 'medicAmount',  label: '医疗保险（元）'},
        {key: 'maternityAmount',  label: '生育保险（元）'},
        {key: 'injuryAmount',  label: '工伤保险（元）'},
        {key: 'loseAmount',  label: '失业保险（元）'},
        {key: 'requestAmount',  label: '小计（元）'},
        {key: 'budgetControlName',  label: '预算控制'},
        {key: 'budgetAnnual',  label: '预算年度'},
        {key: 'budgetSubjectCode',  label: '预算科目编号'},
        {key: 'budgetSubjectFullName',  label: '预算科目名称'},
        {key: 'budgetAmount',  label: '预算金额（元）'},
        {key: 'budgetUsedAmount',  label: '预算已使用金额（元）'},
        {key: 'remarks',  label: '备注'},
      ]
      this.$router.push({
        path: 'cost_claim_detail_table',
        query: {
          fieldsList: fieldsList,
          dataList: this.inputForm.costEventClaimDetailDTOList
        }
      })
    },
    viewBudget() {
      const fieldsList=[
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'budgetControlName',stickyColumn: true, label: '预算控制'},
        {key: 'mainstayCompanyName', label: '费用承担公司'},
        {key: 'budgetProjectName',  label: '预算项目'},
        {key: 'budgetAnnual',  label: '预算年度'},
        {key: 'budgetSubjectCode',  label: '预算科目编码'},
        {key: 'budgetSubjectName',  label: '预算科目名称'},
        {key: 'budgetAmount',  label: '预算金额（元）'},
        {key: 'budgetUsedAmount',  label: '预算已使用金额（元）'},
        {key: 'budgetApportionAmount',  label: '预算分摊金额（元）'},
        {key: 'budgetBalance',  label: '预算余额（元）'},
      ]
      this.$router.push({
        path: 'cost_claim_detail_table',
        query: {
          fieldsList: fieldsList,
          dataList: this.inputForm.costBudgetDTOList
        }
      })
    },
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.unitTitle {
  width: 100%;
  padding-left: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
.m-form {
  width: 100%;
  /*padding: 10px;*/
  font-size: 12px;
  box-sizing: border-box;
  /*border-bottom: 1px solid #eee;*/
  padding-left: 16px;
  margin-bottom: 10px;
}
.title {
  width: calc(100vw - 20px);
  height: 30px;
  background-color: #eeeeee;
  line-height: 30px;
  font-weight: bold;
  padding-left: 5px;
  box-sizing: border-box;
  /*// margin-bottom: 20rpx;*/
}

.m-row {
  display: flex;
  width: calc(100%);
  border: 1px solid #eee;
  border-bottom: 0px;
}

.m-row:last-child {
  border-bottom: 1px solid #eee;
}

.m-row-text {
  width: 110px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  display: flex;
  align-items: center;
  /*background-color: #dedede;*/
}

.m-row-content {
  width: calc(100% - 110px);
  color: black;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.large-content {
  width: calc(100% - 110px);
  min-height: 30px;
  height: auto;
  padding-left: 10px;
  overflow: hidden;
}
</style>
